<qa-donut-chart [sections]="sections" [showProgressBar]="showProgressBar">
</qa-donut-chart>
